<template>
  <!--src/layouts/AdminDashboardLayout.vue-->
  <div v-if="role === 'admin'" class="g-sidenav-show g-sidenav-pinned">
    <AdminSidebar v-show="sidenavOpen" :role="role" />
    <div class="sidenav-backdrop" v-if="sidenavOpen" @click="toggleSidenav" />
    <div class="buzz-navbar-sticky-wrapper">
      <AdminNavbar :sidenavOpen="sidenavOpen" :role="role" @toggle-sidenav="toggleSidenav" />
    </div>
    <main class="main-content position-relative border-radius-lg" :class="{ 'sidenav-open': sidenavOpen }">
      <div class="container-fluid py-4">
        <router-view />
      </div>
    </main>
  </div>
  <div v-if ="role === 'staff'" class="g-sidenav-show g-sidenav-pinned">
    <StaffSidebar v-show="sidenavOpen" :role="role" />
    <div class="sidenav-backdrop" v-if="sidenavOpen" @click="toggleSidenav" />
    <div class="buzz-navbar-sticky-wrapper">
      <StaffNavbar :sidenavOpen="sidenavOpen" :role="role" @toggle-sidenav="toggleSidenav" />
    </div>
    <main class="main-content position-relative border-radius-lg" :class="{ 'sidenav-open': sidenavOpen }">
      <div class="container-fluid py-4">
        <router-view />
      </div>
    </main>
  </div>

  <div v-if="businessTimezone" class="tz-badge">
    <i class="pi pi-clock"></i>
    <span>{{ tzLabel }}</span>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import AdminSidebar from '@/components/BuzzSideNavDash.vue'
import AdminNavbar from '@/components/BuzzDashNav.vue'
import StaffSidebar from '@/components/BuzzSideNavDash.vue'
import StaffNavbar from '@/components/BuzzDashNav.vue'
import { useSessionStore } from '@/stores/session'
import http from '@/lib/http'
import { normalizeTimeZone } from '@/helpers/globalHelper'

const session = useSessionStore()
const sidenavOpen = ref(false)
const role = session.role
const businessTimezone = ref('')

const tzLabel = computed(() => normalizeTimeZone(businessTimezone.value))

function setInitialSidenav() {
  if (typeof window === 'undefined') return
  const mq = window.matchMedia('(min-width: 768px)')
  sidenavOpen.value = mq.matches
  return mq
}

function toggleSidenav() {
  sidenavOpen.value = !sidenavOpen.value
}

onMounted(async () => {
  setInitialSidenav()
  try {
    const res = await http.get('/business/')
    businessTimezone.value = res?.data?.business?.timezone || 'UTC'
  } catch {
    businessTimezone.value = 'UTC'
  }
})
</script>

<style scoped>
.g-sidenav-show {
  background: #f1f5f9;
  min-height: 100vh;
}

.main-content {
  transition: margin-left 0.3s cubic-bezier(.4,2,.6,1);
  margin-left: 0;
}
.main-content.sidenav-open {
  margin-left: 175px;
}

/* Backdrop used only on small screens when sidenav is open */
.sidenav-backdrop {
  display: none;
}
@media (max-width: 768px) {
  .sidenav-backdrop {
    display: block;
    position: fixed;
    inset: 0; /* top:0; right:0; bottom:0; left:0 */
    background: rgba(0,0,0,0.45);
    z-index: 95; /* below the sidebar (100) but above content */
  }
}

/* Sticky navbar wrapper to keep navbar visible while scrolling */
.buzz-navbar-sticky-wrapper {
  position: sticky;
  top: 0;
  z-index: 110;
}
.buzz-navbar {
  z-index: 110;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }
  .main-content.sidenav-open {
    margin-left: 0;
  }
}

/* ── Timezone badge ─────────────────────────────────── */
.tz-badge {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 200;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  background: #243654;
  color: #fff;
  border-radius: 8px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  box-shadow: 0 2px 8px rgba(36, 54, 84, 0.28);
  pointer-events: none;
  white-space: nowrap;
}
.tz-badge i { font-size: 0.68rem; opacity: 0.8; }
</style>
